<div class="w-100 float-left">

    <div class="w-100 float-left v-align relative">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{'ANNOUNCEMENT_ADMIN_MODULE'| translate}}</h5>
        </div>
    </div>

    <div class="w-100 float-left mb-4">
        <div class="form-group w-100 float-left mb-4">
            <label for="f_name">{{'title' | translate}} <span class="text-danger medium">*</span></label>
            <input [(ngModel)]="announcementData.title" autofocus type="text" class="form-control w-100"
                   name="announceTitle" autocomplete="off" placeholder="{{'enterAnnouncementTitle' | translate}}">
        </div>
        <div class="w-100 float-left rich-text-editor mb-4">
            <label for="content">{{'description' | translate}}</label>
            <div class="w-100 float-left">
                <quill-editor [(ngModel)]="announcementData.textContent">
                    <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-italic" [title]="'italic'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-underline" [title]="'Underline'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-list" [title]="'list'" value="ordered">
                    </button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-list" [title]="'list'" value="bullet">
                    </button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-list" [title]="'list'" value="check">
                    </button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-header" [title]="'header'" value="1">
                    </button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-header" [title]="'header'" value="2">
                    </button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-blockquote" [title]="'blockquote'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-formula" [title]="'formula'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-link" [title]="'link'"></button>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-code-block" [title]="'code-block'"></button>
                  </span>

                        <span class="ql-formats">
                    <select class="ql-font" [title]="'font'">
                      <option selected value="sans serif"></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                  </span>

                        <span class="ql-formats">
                    <select class="ql-color" [title]="'color'">
                      <option value="white"></option>
                      <option value="black"></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="green"></option>
                      <option value="lightblue"></option>
                      <option value="orange"></option>
                      <option value="pink"></option>
                      <option value="yellow"></option>
                      <option value="purple"></option>
                      <option value="grey"></option>
                      <option value="lightgreen"></option>
                      <option value="lightyellow"></option>
                      <option value="magenta"></option>
                    </select>
                  </span>

                        <span class="ql-formats">
                    <select class="ql-background" [title]="'background'">
                      <option value="white"></option>
                      <option value="black"></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="green"></option>
                      <option value="lightblue"></option>
                      <option value="orange"></option>
                      <option value="pink"></option>
                      <option value="yellow"></option>
                      <option value="purple"></option>
                      <option value="grey"></option>
                      <option value="lightgreen"></option>
                      <option value="lightyellow"></option>
                      <option value="magenta"></option>
                    </select>
                  </span>

                        <span class="ql-formats">
                    <select class="ql-size" [title]="'font'">
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>

                        <span class="ql-formats">
                    <select class="ql-align" [title]="'Aligment'">
                      <option selected></option>
                      <option value="center"></option>
                      <option value="right"></option>
                      <option value="justify"></option>
                    </select>
                  </span>

                        <span class="ql-formats">
                    <button class="ql-strike" [title]="'strike'"></button>
                  </span>
                    </div>
                </quill-editor>
            </div>
        </div>
        <div class="form-group w-100 float-left mb-4">
            <label for="f_name">Video Link</label>
            <input autosize rows="1" class="form-control" id="announcementVid" name="announcementVid"
                   autocomplete="off" placeholder=" " [(ngModel)]="videoLink" (blur)="onBlurMethod(videoLink)">
        </div>
        <div class="form-group">
            <div class="w-100 float-left mt-2">
                <button class="btn btn-primary relative">
                    <input name="myFile" type="file" class="upload-pic" (change)="fileChange($event); readUrl($event)"
                           onclick="this.value = null" accept="image/*" #fileInput>
                    Attach Images
                    <i class="fa fa-plus ml-1 text-white"></i>
                </button>
            </div>
        </div>
        <div class="form-group">
            <div class="row" *ngIf="allurl.length > 0">
                <div class="col-md-2 mt-4" *ngFor="let URL of allurl; let i = index">
                    <div class="adminAuuouncement">

                        <div class="deleteImg" (click)="deletepic(i)">&times;</div>

                        <img class="img-fluid text-center" [src]="URL">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <h6 class="medium mb-3"> {{'chooseEmpToAnnounce' | translate}} </h6>
            <div class="form-group w-100 float-left mb-2">
                <input type="radio" id="everyone" name="radio-group" (change)="onEmployeeSelectionChange(1)"
                       [checked]="selectEmployeeOption === 1">
                <label for="everyone" class="normal"> {{'includeEveryOne' | translate}} </label>
            </div>
        </div>


        <div class="btn-group float-right mt-4">
            
            <button class="btn btn-primary" [disabled]="buttonStatus" (click)="validateEmps(1)"><i
                    class="fa fa-floppy-o text-white mr-2"></i> {{'makeAnnouncementNow' | translate}}
                <i *ngIf="buttonStatus" class="fa fa-spinner fa-spin text-white m-l-smd"></i></button>

            <button class="btn btn-primary ml-4" [disabled]="buttonStatus" (click)="validateEmps(2)"><i
                    class="fa fa-floppy-o text-white mr-2"></i> {{'scheduleAnnouncement' | translate}}
                <!-- <i *ngIf="buttonStatus" class="fa fa-spinner fa-spin text-white m-l-smd"></i> -->
            </button>

            <button class="btn btn-secondary ml-4" (click)="goToBackPage()"> {{'clear' | translate}}
                <!-- <i *ngIf="buttonStatus" class="fa fa-spinner fa-spin text-white m-l-smd"></i> -->
            </button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/programManagement/announcements/announcements.html